import {
	Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy,
	 ChangeDetectorRef, AfterViewInit, ElementRef
} from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { MessageService } from 'base';
import { DateService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { NavigationService, NetFacadeService } from 'netview';
import { InfoSetView, InfoSetViewEntry, InfoSetViewValue } from 'UvExplorerServer.Dtos.TS/Session';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';

export class CustomSnmpHistoryEntry {
	public groupKey = "";
	public deviceName = "";
	public entryName = "";
	public timestamp = "";
	public value = "";
}

@Component({
	selector: 'custom-snmp-history',
	templateUrl: './customsnmphistory.component.html',
	styleUrls: ['./customsnmphistory.component.scss']
})
export class CustomSnmpHistoryComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

	@Input()
	public visible: boolean;

	@Input()
	public monitorType: string;

	@Input()
	public deviceGuid: string;

	@Input()
	public monitorPolicyGuid: string;

	private data: InfoSetView;
	public entries: CustomSnmpHistoryEntry[];
	public rowGroupMetadata: any;

	private destroyed: boolean;
	private eventsInterval: number;
	private timerId: any;

	constructor(private element: ElementRef,
		private monitorService: MonitorService,
		private messageService: MessageService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private netFacadeService: NetFacadeService,
		private dateService: DateService,
		private changeDetector: ChangeDetectorRef) {

		this.monitorType = "";
		this.deviceGuid = "";
		this.monitorPolicyGuid = "";

		this.data = null;
		this.entries = [];
		this.rowGroupMetadata = {};

		this.destroyed = false;
		this.eventsInterval = 0;
		this.timerId = undefined;
	}

	public formatDateHm(date: string | Date): string {
		return this.dateService.formatDateHm(date);
	}

	public ngOnInit(): void {
		if (this.visible && this.navService.isNetworkLoaded) {
			this.startTimer();
		}
	}

	public ngAfterViewInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (this.destroyed)
			return;

		this.stopTimer();
		if (this.visible && this.navService.isNetworkLoaded) {
			this.retrieveMonitorHistory(true);
			this.startTimer();
		}
	}

	public ngOnDestroy(): void {
		this.stopTimer();
	}

	private setEventsInterval(): void {
		this.eventsInterval = 0;

		let netViewGuid = this.navService.location.netViewGuid;
		let network: NetViewDto = this.netFacadeService.findNetwork(netViewGuid);
		if (network) {
			this.eventsInterval = network.EventsInterval;
		}
		else {
			this.messageService.displayErrorMessage("Could not set events interval");
		}
	}

	private startTimer(): void {

		this.setEventsInterval();

		if (!this.timerId && this.visible && this.eventsInterval > 0) {
			let timeoutMillis = this.eventsInterval * 1000;
			this.timerId = setInterval(() => {
				this.retrieveMonitorHistory(false);
				//console.log("Turn timer back on");
			}, timeoutMillis);
		}
	}

	private stopTimer(): void {
		if (this.timerId) {
			clearInterval(this.timerId);
			this.timerId = undefined;
		}
	}

	private retrieveMonitorHistory(showBusy: boolean): Observable<boolean> {

		if (!!this.monitorType && (!!this.deviceGuid || !!this.monitorPolicyGuid)) {

			let sessionGuid = this.identityService.sessionGuid;
			let netViewGuid = this.navService.location.netViewGuid;
			let agentGuid = this.navService.location.agentGuid;
			let schedDiscGuid = this.navService.location.schedDiscGuid;
			let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

			let subject = new Subject<any>();

			this.monitorService.getMonitorHistory(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
				schedDiscRsltGuid, this.monitorType, this.monitorPolicyGuid, this.deviceGuid, showBusy).subscribe(
					(result: InfoSetView) => {
						this.data = result;
						this.rebuildEntries();
						subject.next(true);
					},
					(error) => {
						this.data = null;
						this.rebuildEntries();
						this.messageService.displayErrorMessage("Could not retrieve monitor history");
						subject.error(false);
					});

			return subject;
		}
		else {
			this.data = null;
			this.rebuildEntries();
			return new Observable<boolean>(observer => {
				observer.error(false);
			});
		}
	}

	private rebuildEntries(): void {
		this.entries = [];

		if (!!this.data) {
			this.data.entries.forEach((isvEntry: InfoSetViewEntry) => {
				let entry = new CustomSnmpHistoryEntry();
				entry.deviceName = isvEntry.values[0].value;
				entry.entryName = isvEntry.values[1].value;
				entry.timestamp = isvEntry.values[2].value;
				entry.value = isvEntry.values[3].value;
				entry.groupKey = isvEntry.groupKey;

				//console.log(entry.groupKey);

				this.entries.push(entry);
			});
		}

		this.rebuildRowGroupMetaData();
	}

	private rebuildRowGroupMetaData() {
		this.rowGroupMetadata = {};
		if (!!this.data) {
			for (let i = 0; i < this.entries.length; i++) {
				let rowData = this.entries[i];
				let groupKey = rowData.groupKey;
				if (i == 0) {
					this.rowGroupMetadata[groupKey] = { index: 0, size: 1 };
				}
				else {
					let previousRowData = this.entries[i - 1];
					let previousRowGroup = previousRowData.groupKey;
					if (groupKey === previousRowGroup)
						this.rowGroupMetadata[groupKey].size++;
					else
						this.rowGroupMetadata[groupKey] = { index: i, size: 1 };
				}
			}
		}
	}

}
